import keyBy from 'lodash/keyBy';
import { allCountries, iso2Lookup } from 'country-telephone-data';

import { translateMessage } from 'common/components/Intl';

// Countires we have our own flags for
// prettier-ignore
export const supportedFlagCountryCodes = [
  'AT', 'BE', 'CA', 'CH', 'CO', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'GR', 'ID', 'IE', 'IL', 'IN', 'IT', 'KR', 'NL', 'NO', 'NZ', 'PE', 'PH', 'PL', 'PR', 'PT', 'RU', 'SE', 'SK', 'UA', 'US', 'ZA'];

export const supportedCountryNames = {
  AT: 'common.countries.austria',
  BE: 'common.countries.belgium',
  CA: 'common.countries.canada',
  CH: 'common.countries.switzerland',
  CO: 'common.countries.colombia',
  CZ: 'common.countries.czech_republic',
  DE: 'common.countries.germany',
  DK: 'common.countries.denmark',
  ES: 'common.countries.spain',
  FR: 'common.countries.france',
  GB: 'common.countries.uk',
  GR: 'common.countries.greece',
  ID: 'common.countries.indonesia',
  IE: 'common.countries.ireland',
  IL: 'common.countries.israel',
  IN: 'common.countries.india',
  IT: 'common.countries.italy',
  KR: 'common.countries.korea',
  NL: 'common.countries.netherlands',
  NO: 'common.countries.norway',
  NZ: 'common.countries.new_zealand',
  PE: 'common.countries.peru',
  PH: 'common.countries.philippines',
  PL: 'common.countries.poland',
  PR: 'common.countries.puerto_rico',
  PT: 'common.countries.portugal',
  RU: 'common.countries.russia',
  SE: 'common.countries.sweden',
  SK: 'common.countries.slovakia',
  UA: 'common.countries.ukraine',
  US: 'common.countries.usa',
  ZA: 'common.countries.south_africa',
};

export const getSupportedCountryNameFromISO = isoCode => {
  if (typeof isoCode === 'string') {
    return supportedCountryNames[isoCode.toUpperCase()];
  }
};

export const getCountryNameFromISO = isoCode => {
  if (typeof isoCode !== 'string') {
    return;
  }

  if (iso2Lookup[isoCode.toLowerCase()] !== undefined) {
    return `common.country_by_iso.${isoCode.toLowerCase()}`;
  }
};

// Add additional properties here as needed
export const getCountriesList = intl => {
  return allCountries.map(country => {
    const countryName = getCountryNameFromISO(country.iso2);
    const displayName = countryName
      ? translateMessage(intl, countryName)
      : country.name;
    return {
      callingCode: country.dialCode,
      countryCode: country.iso2.toUpperCase(),
      fullName: country.name,
      callingPrefix: `+${country.dialCode}`,
      name: displayName,
    };
  });
};

export const getCountriesMap = intl =>
  keyBy(getCountriesList(intl), 'countryCode');
